import {uiActions} from '../chrome';

// See https://developers.facebook.com/docs/sharing/reference/share-dialog
const BASE_FACEBOOK_SHARE_PATH = 'https://www.facebook.com/dialog/share?app_id=1531841530217150';

// See https://developer.linkedin.com/docs/share-on-linkedin
const BASE_LINKEDIN_SHARE_PATH = 'https://www.linkedin.com/shareArticle';

const DEFAULT_TITLE = 'B2Me Australia';
const DEFAULT_DESCRIPTION = 'B2Me helps you to find people that you can trust from your community';

export const getProfileLink = uniqueName =>
	encodeURIComponent(window.location.origin + '/@' + uniqueName);

export const copyProfileLink = uniqueName => dispatch => {
	const link = window.location.origin + '/@' + uniqueName;
	if (!navigator.clipboard) {
		// fallback to sync copy
		var textArea = document.createElement('textarea');
		textArea.value = link;

		// Avoid scrolling to bottom
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.position = 'fixed';

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			var successful = document.execCommand('copy');
			if (!successful) throw Error();
			dispatch(uiActions.uiMessage('Successfully copied to clipboard!'));
		} catch (err) {
			dispatch(uiActions.uiMessage('Error copying profile to clipboard'));
		}

		document.body.removeChild(textArea);
	} else {
		navigator.clipboard
			.writeText(link)
			.then(() => dispatch(uiActions.uiMessage('Successfully copied to clipboard!')))
			.catch(() => dispatch(uiActions.uiMessage('Error copying profile to clipboard')));
	}
};

export const getShareB2MeFacebook = () => {
	const origin = encodeURIComponent(window.location.origin);
	const href = encodeURIComponent(window.location.href);
	return (window.location.href = `${BASE_FACEBOOK_SHARE_PATH}&href=${origin}&redirect_uri=${href}&display=page`);
};

export const getShareProfileFacebook = uniqueName => () => {
	const link = getProfileLink(uniqueName);
	window.location.href =
		BASE_FACEBOOK_SHARE_PATH + `&href=${link}&redirect_uri=${link}&display=page`;
};

export const getShareB2MeLinkedin = () => {
	const origin = encodeURIComponent(window.location.origin);
	const href = encodeURIComponent(window.location.href);
	return (window.location.href = `${BASE_LINKEDIN_SHARE_PATH}?url=${href}&mini=true&title=${DEFAULT_TITLE}&summary=${DEFAULT_DESCRIPTION}&source=${origin}`);
};

export const getShareProfileLinkedin = (
	uniqueName,
	firstname,
	lastname,
	brief,
	subject = 'profile'
) => () => {
	const link = getProfileLink(uniqueName);

	const o = {
		uniqueName: encodeURIComponent(uniqueName),
		title:
			firstname && lastname
				? `${encodeURIComponent(firstname)} ${encodeURIComponent(lastname)}'s ${subject} on B2Me`
				: DEFAULT_TITLE,
		summary: brief ? encodeURIComponent(brief) : DEFAULT_DESCRIPTION,
		source: encodeURIComponent(window.location.href)
	};

	window.location.href = `${BASE_LINKEDIN_SHARE_PATH}?url=${link}&mini=true&title=${
		o.title
	}&summary=${o.summary}&source=${o.source}`;
};



// WEBPACK FOOTER //
// ./src/profile/sharing.util.js